export const buildTooltipStyle = (theme) => ({
  contentStyle: {
    background: theme.color.surface,
    border: `1px solid ${theme.color.border}`,
    borderRadius: theme.radius.sm,
    boxShadow: theme.shadow.md,
    fontSize: theme.font.size.sm,
    fontFamily: theme.font.family,
    color: theme.color.text,
  },
  labelStyle: { color: theme.color.textSoft, fontWeight: 500, marginBottom: 4 },
});
